import { isTextColor, getColor, isTextHighlight } from './text-decorations-utils.js';
import { isHexColor } from 'wix-rich-content-common';
import './types.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const DEFAULT_PALETTE = Object.freeze([
  "#ffffff",
  "#303030",
  "#3a54b4",
  "#bfad80",
  "#bf695c",
  "#f7f7f7"
]);
const DEFAULT_COLOR = "#000000";
const DEFAULT_HIGHLIGHT_COLOR = "#ffffff";
const PANEL_WIDTH = 216;
const PANEL_HEIGHT = 116;
const DEFAULT_STYLE_SELECTION_PREDICATE = (style) => isHexColor(style);
const DEFAULT_FOREGROUND_STYLE_FN = (style) => {
  if (isTextColor(style)) {
    const color = getColor(style);
    return isHexColor(color) ? { color } : {};
  }
  return {};
};
const DEFAULT_FOREGROUND_STYLE_FN_DRAFT = (styles) => styles.toArray().reduce((cssStyle, style) => __spreadValues(__spreadValues({}, cssStyle), DEFAULT_FOREGROUND_STYLE_FN(style)), {});
const DEFAULT_BACKGROUND_STYLE_FN = (style) => {
  if (isTextHighlight(style)) {
    const color = getColor(style);
    return isHexColor(color) ? { backgroundColor: color, transition: "all .8s" } : {};
  }
  return {};
};
const DEFAULT_BACKGROUND_STYLE_FN_DRAFT = (styles) => styles.toArray().reduce((cssStyle, style) => __spreadValues(__spreadValues({}, cssStyle), DEFAULT_BACKGROUND_STYLE_FN(style)), {});
let userColors = [];
const DEFAULTS = {
  configTextColor: {
    editor: {
      onColorAdded: (color) => userColors = [...userColors, color],
      getUserColors: () => userColors
    },
    viewer: {}
  },
  configTextHighlight: {
    editor: {
      onColorAdded: (color) => userColors = [...userColors, color],
      getUserColors: () => userColors
    },
    viewer: {}
  }
};

export { DEFAULTS, DEFAULT_BACKGROUND_STYLE_FN, DEFAULT_BACKGROUND_STYLE_FN_DRAFT, DEFAULT_COLOR, DEFAULT_FOREGROUND_STYLE_FN, DEFAULT_FOREGROUND_STYLE_FN_DRAFT, DEFAULT_HIGHLIGHT_COLOR, DEFAULT_PALETTE, DEFAULT_STYLE_SELECTION_PREDICATE, PANEL_HEIGHT, PANEL_WIDTH };
//# sourceMappingURL=constants.js.map
